<template>
  <div>
    <router-view v-if="render"/>
    <ConnectionStatus />
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import { toast } from "vue3-toastify";
import pingSound from "@/assets/audio/ping_sound.mp3";
import { h } from "vue";
import axios from "axios";
import ConnectionStatus from "./views/ConnectionStatus.vue";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
      render: true,
    };
  },
  components: {
    ConnectionStatus
  },
  mounted() {
    this.audio = new Audio(pingSound);

    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      connect(this.userId);

      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      socket.on("ping", (data) => {
        const notificationType = String(
          data?.notificationType || ""
        ).trim().toLowerCase();

        const isSilentCommentUpdate = [
          "comment_edit",
          "comment_delete",
        ].includes(notificationType);

        if (!isSilentCommentUpdate) {
          toast.success(
            () =>
              h(
                "div",
                {
                  class: "flex w-full items-start gap-3 p-1",
                },
                [
                  h("div", {
                    class:
                      "mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-green-500",
                  }),

                  h(
                    "div",
                    {
                      class: "flex min-w-0 flex-1 flex-col gap-2",
                    },
                    [
                      h(
                        "div",
                        {
                          class:
                            "break-words text-xs font-medium leading-snug text-gray-800",
                        },
                        data.message
                      ),

                      h(
                        "div",
                        {
                          class: "flex items-center justify-start",
                        },
                        [
                          h(
                            "button",
                            {
                              class:
                                "inline-flex items-center gap-1 rounded-md bg-green-600 px-3 py-1.5 text-xs font-medium text-white shadow-sm transition-all duration-150 hover:bg-green-700 active:scale-[0.98]",
                              onClick: (e) => {
                                e.stopPropagation();

                                if (!data.route) return;

                                if (typeof data.route === "string") {
                                  const route = data.route.startsWith("/")
                                    ? data.route
                                    : `/${data.route}`;

                                  this.$router.push(route).catch(() => {});
                                  return;
                                }

                                if (data.route.name) {
                                  this.$router
                                    .push({
                                      name: data.route.name,
                                      query: data.route.query || {},
                                      params: data.route.params || {},
                                    })
                                    .catch(() => {});

                                  return;
                                }

                                if (data.route.path) {
                                  this.$router
                                    .push({
                                      path: data.route.path,
                                      query: data.route.query || {},
                                    })
                                    .catch(() => {});
                                }
                              },
                            },
                            "View details"
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            {
              autoClose: 15000,
              closeOnClick: false,
              closeButton: true,
              hideProgressBar: false,
              position: "bottom-right",
              pauseOnHover: true,
              draggable: false,

              style: {
                width: "390px",
                maxWidth: "calc(100vw - 2rem)",
                borderLeft: "4px solid #16a34a",
                boxShadow: "0 12px 30px rgba(0, 0, 0, 0.14)",
              },

              className:
                "border border-green-100 rounded-xl bg-white",
            }
          );
        }

        window.dispatchEvent(
          new CustomEvent("notifications-updated", {
            detail: {
              source: "socket-ping",
              notificationId:
                data?.notificationId || null,
              notificationType:
                data?.notificationType || null,
              route:
                data?.route || null,
            },
          })
        );

        if (!isSilentCommentUpdate) {
          this.playPingSound();
        }
      });

      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },

  methods: {
    getUser() {
      const localToken = localStorage.getItem("token");

      if (!localToken) {
        this.render = true;
        localStorage.clear();
        this.$router.replace("/");
        return;
      }

      this.render = false;
      console.log("TOKEN SENT TO AUTH ME:", localToken);

      axios
        .get(process.env.VUE_APP_BASE_URL + "/auth/me", {
          headers: {
            Authorization: `Bearer ${localToken}`,
          },
        })
        .then((res) => {
          const user = res.data.data;

          this.$store.dispatch("setUser", user);
          localStorage.setItem("user_id", user.id);
          this.$store.commit("UPDATE_USER", user);

          const publicPages = ["/", "/login"];

          if (publicPages.includes(this.$route.path)) {
            this.$router.replace("/dashboard");
          }
        })
        .catch((err) => {
          console.log(err);
          localStorage.clear();
          this.$router.replace("/");
        })
        .finally(() => {
          this.render = true;
        });
    },

    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style>
.Toastify__toast-container--bottom-right {
  right: 1.25rem !important;
  bottom: 1.25rem !important;
  left: auto !important;
  top: auto !important;
}

@media (max-width: 640px) {
  .Toastify__toast-container--bottom-right {
    right: 0.75rem !important;
    bottom: 0.75rem !important;
    left: 0.75rem !important;
    width: auto !important;
  }
}
</style>
